export const STUDENT_DIRECTORY_SORTS = [
  "name",
  "next-lesson",
  "last-lesson",
  "last-active",
] as const;

export type StudentDirectorySort = (typeof STUDENT_DIRECTORY_SORTS)[number];

/**
 * The directory is server-paginated, so the sort must be understood by the
 * server before a page is selected. Unknown values fall back to the stable
 * name order rather than becoming an untrusted SQL fragment.
 */
export function parseStudentDirectorySort(value: unknown): StudentDirectorySort {
  if (typeof value !== "string") return "name";
  return STUDENT_DIRECTORY_SORTS.includes(value as StudentDirectorySort)
    ? (value as StudentDirectorySort)
    : "name";
}
